import { ApiConfigService as n, ConfigService as s } from "@nextgen-web-framework/core";
const c = (e) => {
  const t = n.getTuples(), o = s.getConfigs();
  let i = "";
  if (typeof window < "u") {
    const r = {
      redirectUri: window.location.href,
      headers: t,
      amwayLang: e
    };
    o.NEXT_PUBLIC_LOGIN_URL && (r.loginUrl = o.NEXT_PUBLIC_LOGIN_URL), i = btoa(JSON.stringify(r));
  }
  return {
    scope: "openid",
    state: i,
    countryIso: t["X-Amway-Country"],
    redirectUri: o.NEXT_PUBLIC_OIDC_URL ? `${o.NEXT_PUBLIC_OIDC_URL}` : ""
  };
}, U = () => {
  const e = s.getConfigs(), t = n.getBaseUrl(), o = btoa(JSON.stringify({ redirectUri: `${e.NEXT_PUBLIC_WEB_BASE_PATH}/logout` }));
  return {
    postLogoutRedirectUri: `${t}/comgluuoidc/v1/logout?state=${o}`
  };
};
export {
  c as getLoginProps,
  U as getLogoutProps
};
//# sourceMappingURL=auth.js.map
